// src/pages/Diagnosis.js
import React, { useState, useRef } from 'react';
import '../styles/Diagnosis.css';
import Card from '../components/Card';
import Button from '../components/Button';
import { getUserRole, getLoginCode } from '../components/Auth';
import Modal from '../components/Diagnosis/Modal.jsx';

const Diagnosis = () => {
  const [isAppOpen, setAppOpen] = useState(false);
  const [isManualOpen, setManualOpen] = useState(false);
  const iframeRef = useRef(null);

  return (
    <div className="page">
      <h1 className="title">適職診断システム</h1>

      <Card title="適職診断システム">
        <ul className="diagnosis-link-list">
          <li>
            <Button onClick={() => setAppOpen(true)}>
              適職診断を始める
            </Button>
          </li>
          <li>
            <Button onClick={() => setManualOpen(true)}>
              診断マニュアルを見る
            </Button>
          </li>
        </ul>
      </Card>

      <Card title="デモ動画">
        <div className="diagnosis-video-container">
          <iframe
            src="https://www.youtube.com/embed/RSGLsMh5wCc"
            title="デモ動画"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        </div>
      </Card>

      {/* 適職診断モーダル */}
      <Modal
        isOpen={isAppOpen}
        onClose={() => setAppOpen(false)}
        title="適職診断を始める"
      >
        <iframe
          ref={iframeRef}
          src="https://findjob.myou-kou.com/useraccess"
          name="diagnosisIframe"
          title="適職診断サイト"
          className="diagnosis-modal-iframe"
          onLoad={() => {
            //console.log("トークン送信：", getLoginCode());
            setTimeout(() => {
              iframeRef.current?.contentWindow?.postMessage(
                { type: 'SET_TOKEN', token: getLoginCode() },
                'https://findjob.myou-kou.com'
              );
            }, 1000);
          }}
        />
      </Modal>

      {/* 診断マニュアルモーダル */}
      <Modal
        isOpen={isManualOpen}
        onClose={() => setManualOpen(false)}
        title="診断マニュアル"
      >
        <iframe
          src="/download/適職診断システム（利用者用マニュアル）.pdf"
          title="診断マニュアル"
          className="diagnosis-modal-iframe"
        />
        <p className="diagnosis-download-text">
          PDF が表示されない場合は
          <a
            href="/download/適職診断システム（利用者用マニュアル）.pdf"
            target="_blank"
            rel="noopener noreferrer"
            className="diagnosis-download-link"
          >
            こちら
          </a>
          からダウンロードしてください。
        </p>
      </Modal>
    </div>
  );
};

export default Diagnosis;
